export default "__VITE_ASSET__D00gbAn0__"